{
  "salon-details-page": {
    "buttons": {
      "next": "DALŠÍ"
    },
    "meta": {
      "description": "Navštivte salon {{salon}} - {{address}}, rezervujte si schůzku online 24/7 a získejte skvělé slevy"
    }
  }
}
